import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'filter-bar',
  templateUrl: './filter-bar.component.html',
  styleUrls: ['./filter-bar.component.scss']
})
export class FilterBarComponent implements OnInit {

  /**
   * List of categories to filter
   */
  @Input() categories: Category[];
  /**
   * Fires when user change the categories
   */
  @Output() selectedcategories = new EventEmitter<Number[]>();
  /**
   * Fires when user change the text in the input filter.
   */
  @Output() textFilter = new EventEmitter<String>();

  constructor() { }

  ngOnInit() {
    
  }

  onSelection(e, v){    
    this.selectedcategories.emit(v.selected.map(item => item.value));
  }

  onTextFilterChange(event){
    this.textFilter.emit(event.target.value);
  }
}


export interface Category {
  Id: Number;
  Name: String;
}